import React, {Component} from 'react';
import PropTypes from 'prop-types';
import EnvironmentBanner from './EnvironmentBanner';

export class AppTopbarMerchant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            noticeCount: 0,
            header: '',
        };
    }

    componentDidMount = () => {

    }

    render() {
        return (
            <div className="app-merchant-topbar-wrap">
                <header>
                    {this.state.header !== '' &&
                        <img src={this.state.header} width="100%" height="100%" alt="" style={{maxHeight: '65px'}}/>
                    }
                    <EnvironmentBanner />
                    <div className="layout-topbar app-merchant-topbar clearfix">
                        <a className="layout-menu-button" onClick={this.props.onToggleMenu} aria-label="Toggle menu">
                            <span className="pi pi-bars"/>
                        </a>

                        <div className="app-merchant-topbar__actions">
                            <a
                                className="app-merchant-topbar__btn"
                                title="Back"
                                aria-label="Back"
                                onClick={() => {
                                    const location = window.location.toString();
                                    if (!location.endsWith('#/')) {
                                        window.history.back();
                                    }
                                }}>
                                <span className="layout-topbar-icon pi pi-angle-left"/>
                            </a>
                            <a
                                className="app-merchant-topbar__btn"
                                title="Home"
                                aria-label="Home"
                                onClick={() => {
                                    window.location = '#/';
                                }}>
                                <span className="layout-topbar-icon pi pi-home"/>
                            </a>
                            <a
                                className="app-merchant-topbar__btn"
                                title="Log out"
                                aria-label="Log out"
                                onClick={this.props.logout}>
                                <span className="layout-topbar-icon pi pi-power-off"/>
                            </a>
                        </div>
                    </div>
                </header>
            </div>
        );
    }
}

AppTopbarMerchant.propTypes = {
    onToggleMenu: PropTypes.func.isRequired,
    logout: PropTypes.func
};

AppTopbarMerchant.defaultProps = {
    onToggleMenu: null
};
